import { createRoot } from 'react-dom/client';

import { TReduxStore } from '../../../shared/types/redux';
import { EApplicationType, IApplicationContext } from '../../../shared/types/applicationContext';
import { DailyrentApplication } from '../../../shared/containers/DailyrentApplication';
import { Application } from '../../../shared/containers/App';

interface IDependencies {
  store: TReduxStore;
  context: IApplicationContext;
}

export function renderApplication(dependencies: IDependencies) {
  const { store, context } = dependencies;
  const { config, custom } = context;

  const projectName = config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName);

  /**
   * applicationType устанавливается в handler'е страницы
   */
  const { applicationType } = custom;
  const RootApplication = applicationType === EApplicationType.Dailyrent ? DailyrentApplication : Application;

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  const root = createRoot(rootElement);
  root.render(<RootApplication context={context} reduxStore={store} />);
}
